import { render, staticRenderFns } from "./SlideForms.vue?vue&type=template&id=4744d647&"
import script from "./SlideForms.vue?vue&type=script&lang=js&"
export * from "./SlideForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports